import energyDataRoutes from './routes/energyDataRoutes.js';

export default [...energyDataRoutes];
